module.exports = __webpack_public_path__ + "img/14.1bf564b7.jpg";